import { fullSlice } from '@client/product/redux/products/full/redux';
import { tileSlice } from '@client/product/redux/products/tile/redux';
import { combineSlices } from '@reduxjs/toolkit';

export const productsReducer = combineSlices(fullSlice, tileSlice);
